var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSh1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 209,
    viewBox: "0 0 206 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-1079.5 -2007)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "won_t_report",
    "data-name": "won\\u2019t report",
    transform: "translate(1182.5 2119)",
    fill: "#4c2750",
    fontSize: 70,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -79.625,
    y: 0
  }, "WON\u2019T"), /*#__PURE__*/React.createElement("tspan", {
    x: -102.935,
    y: 65
  }, "REPORT")), /*#__PURE__*/React.createElement("text", {
    id: "Shame_increases_the_likelihood_that_people",
    "data-name": "Shame increases the likelihood that people",
    transform: "translate(1182.5 2031)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -85.98,
    y: 0
  }, "SHAME INCREASES THE "), /*#__PURE__*/React.createElement("tspan", {
    x: -92.99,
    y: 22
  }, "LIKELIHOOD THAT PEOPLE")), /*#__PURE__*/React.createElement("text", {
    id: "their_abuse",
    "data-name": "their abuse",
    transform: "translate(1182.5 2210)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -47.89,
    y: 0
  }, "THEIR ABUSE")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh1);
export default __webpack_public_path__ + "static/media/sh1.289ced5c277438fdab9e24e8ccab3b65.svg";
export { ForwardRef as ReactComponent };